import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { TableInterface } from 'src/app/models/interface/table/tableInterface';
import { ProcessDetailsObject } from 'src/app/models/orders/order-details-process/process-details/process-details-object.model';
import { TechnicalSubprocessObject } from 'src/app/models/orders/order-details-process/process-details/technical-subprocess-object.model';
import { TaskOperationDto } from 'src/app/models/tasks/task-operation/task-operation-dto';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { TasksService } from 'src/app/services/api/tasks/tasks.service';
import { DialogTaskOperationComponent } from '../dialog-task-operation/dialog-task-operation.component';

export enum ComponentStateEnum {
	none = 'none',
	loading = 'loading',
	nodata = 'nodata',
	ready = 'ready',
}

@Component({
  selector: 'app-process-details',
  templateUrl: './process-details.component.html',
  styleUrls: ['./process-details.component.scss']
})
export class ProcessDetailsComponent implements OnInit, OnChanges {

  private _processDetails: ProcessDetailsObject;
  componentState: BehaviorSubject<ComponentStateEnum> = new BehaviorSubject<ComponentStateEnum>(ComponentStateEnum.none);
  @Input()
  get processDetails(): any {
    return this._processDetails;
  }
  set processDetails(value: any) {
    this._processDetails = value;
    this.ngOnInit();
  }

  showSubprocess = false;
  showTaskOperations = false;
  dataSource: MatTableDataSource<TaskOperationDto | TechnicalSubprocessObject>;
  columnsSubprocess: string[] = ['name', 'type', 'status', 'startDate'];
  columnsTaskOperations: string[] = ['executionDate','activity','operationType', 'statusOperation', 'operationActionType', 'comment', 'user'];
  columnsToDisplay: string[];

  translatable: string[] = ['operationType', 'statusOperation', 'operationActionType'];
  hasToolTip: string[] = ['comment', 'user'];

  columnsObj: TableInterface[];

  constructor(private tasksService: TasksService, 
    private dialog: MatDialog, 
    private translateService: TranslateService,
    private notificationsService: NotificationsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.processDetails){
      this.showTaskOperations = false;
      this.showSubprocess = false;
      this.componentState.next(ComponentStateEnum.none);
    }
  }

  ngOnInit() {
  }

  public showSubprocessTable() {
    this.componentState.next(ComponentStateEnum.none);
    this.showSubprocess = !this.showSubprocess;
    this.showTaskOperations = false;
    if (this.showSubprocess === true) {
      this.setTable(this.columnsSubprocess);
      this.columnsToDisplay = this.columnsSubprocess;
      this.dataSource = new MatTableDataSource<TechnicalSubprocessObject>(this.processDetails.getSubprocessList());
      this.componentState.next(ComponentStateEnum.ready);
    } 
  }

  getTasksOperations() {
    this.componentState.next(ComponentStateEnum.none);
    this.showTaskOperations = !this.showTaskOperations;
    this.showSubprocess = false;
    if (this.showTaskOperations === true) {
      this.tasksService.getTasksOperationsByProcess(this._processDetails.getId()).subscribe(
        (data: TaskOperationDto[]) => {
          if(data.length > 0){
            this.setTable(this.columnsTaskOperations);
            this.columnsToDisplay = this.columnsTaskOperations;
            this.dataSource = new MatTableDataSource<TaskOperationDto>(data);
            this.componentState.next(ComponentStateEnum.ready);
          } else {
            this.componentState.next(ComponentStateEnum.nodata);
            console.log(this.componentState);
          }
        },
        (error) => {
          this.notificationsService.showNotification(this.translateService.instant('DIALOG_TASK_OPERATION_KEY.error'), NotificationLevel.ERROR);
          this.componentState.next(ComponentStateEnum.nodata);
        }
      );
    }
  }


  setTable(columns: string[]){
    this.columnsObj = columns.map(column => {
      let translatable = this.translatable.includes(column);
      let hasToolTip = this.hasToolTip.includes(column);

      return {
        columnName: column,
        i18n: 'ORDER_PROCESS_TABLE_KEY.',
        hasToolTip: hasToolTip,
        translatable: translatable,
        css: 'col-ellipsis'
      };
    })

  }

  handleOnRowClick(element: TaskOperationDto | TechnicalSubprocessObject){
    if(element instanceof TaskOperationDto){
      this.dialog.open(DialogTaskOperationComponent, {
        data: { title: this.translateService.instant('DIALOG_TASK_OPERATION_KEY.title'), taskOperation: element},
        disableClose: false,
        maxWidth: '80vw'
      });
    }
  }

}
